


































import { Component, Prop, Watch, Vue } from "vue-property-decorator";
import IconEye from "@/components/icons/IconEye.vue";
import IconEyeClosed from "@/components/icons/IconEyeClosed.vue";
import IconRuble from "@/components/icons/IconRuble.vue";
import { commonModule, pricesModule } from "@/plugins/store-accessors";
import Popover from "@/components/common/Popover.vue";

@Component({
  components: { IconRuble, Popover, IconEyeClosed, IconEye },
})
export default class ButtonsFloat extends Vue {
  opened = false;

  get prices() {
    return pricesModule.getPrices;
  }

  get currentPrice() {
    return pricesModule.getCurrentPrice;
  }

  get currentData() {
    return pricesModule.getCurrentData;
  }

  setValue(data: number | "hide") {
    pricesModule.setCurrentPrice(data);
    this.opened = false;
  }

  togglePopover() {
    this.opened = !this.opened;
  }

  onClickOutside(event: MouseEvent) {
    this.opened = this.$el.contains(event.target as Node) && this.opened;
  }

  mounted() {
    document.addEventListener("click", this.onClickOutside);
    if (!isNaN(Number(localStorage.getItem("currentPrice")))) {
      pricesModule.setCurrentPrice(
        Number(localStorage.getItem("currentPrice")),
      );
    } else if (localStorage.getItem("currentPrice") === '"hide"') {
      pricesModule.setCurrentPrice("hide");
    }
  }

  beforeDestroy() {
    document.removeEventListener("click", this.onClickOutside);
  }
}
